<template lang="pug">
  v-popover(
    :placement='actionsPlacement'
    :delay='{show: 100, hide: 600}'
    trigger='hover click'
    popoverClass='krea-actions-popover'
    :container='false'
  )
    .column
      .row.middle.m-bottom-05
        simple-svg.black-icon.m-right-1(:filepath='evaluationMethodIcon' width='20px' height='20px')
        label.text-small.dark-gray {{ innerI18n.t("krea.educationalContent.features.evaluationMethod") }}
      krea-multiple-k-select.select.m-left-3(
        v-if='edition || !resource.evaluationMethodIds.length'
        name='evaluationMethodIds'
        :maxSelected='10'
        keyName='id'
        :value='resource.evaluationMethodIds'
        :options='evaluationMethodOptions'
        @selectOption='editEvaluationMethod'
        noActions small
        :placeholder='innerI18n.t("krea.educationalContent.features.evaluationMethodPlaceholder")'
      )
      p.text-normal.m-left-3.m-top-1(v-if='methods') {{ methods }}
    template(slot="popover")
      actions(
        @edit='toggleEdition'
        :edit='edit'
        :comments='comments'
        :pdf='pdf'
        :link='link'
        :info='info'
        :placement='actionsPlacement.split("-")[1]'
      )
</template>

<script>
import Actions from './Actions/Actions'
import KreaMultipleKSelect from './KreaMultipleKSelect'
import kreaActions from '@/mixins/kreaActions'
import { mapActions, mapState } from 'vuex'
import { i18n, innerI18n } from '../../../main'
import evaluationMethodIcon from '@/assets/ic_evaluation_method.svg'

export default {
  mixins: [ kreaActions ],
  components: { KreaMultipleKSelect, Actions },
  data() {
    return {
      innerI18n,
      evaluationMethodIcon,
      edition: true
    }
  },
  computed: {
    ...mapState({
      evaluationMethods: state => state.dashboard.evaluationMethods,
      resource: state => state.kreaResource.resource
    }),
    methods() {
      return this.evaluationMethods
        .filter(met => this.resource.evaluationMethodIds.includes(met.id))
        .map(met => innerI18n.t(`evaluationMethods.${met.referenceId}`))
        .join(', ')
    },
    evaluationMethodOptions() {
      return this.evaluationMethods.map(met => ({
        ...met,
        value: met.id,
        label: i18n.t(`evaluationMethods.${met.referenceId}`)
      }))
    }
  },
  methods: {
    ...mapActions([
      'editKreaResourceField'
    ]),
    editEvaluationMethod(field, value) {
      this.editKreaResourceField({ field, value })
    },
    toggleEdition() {
      this.edition = !this.edition
    }
  }
}
</script>

<style lang="scss" scoped>
.select{
  width: 167px;
}
</style>
